import { PetStrings } from '../../constants';

export const getPetSizeFromWeight = (weight: number) => {
  const size = PetStrings.SizeOptions.find(
    (sizeOption) => sizeOption.weightValue === weight,
  )?.value;

  return size;
};
